import { render } from "./CareersArrow.vue?vue&type=template&id=878f1d0c"
import script from "./CareersArrow.vue?vue&type=script&lang=js"
export * from "./CareersArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__